export const changelog_en = [
    {
      versions: [
        {
          name: 'Version 6.0',
          date: 'April 1st, 2023',
        },
      ],
  
      details: [
        {
          topHeading: 'Welcome to version 6.0!',
          topPara: `This is a new generation of ServerChameleon's admin portal, based on APIs and a ReactJS front end, same as the live customer portal.`,
          bottomPara: 'All these features will continue expanding over time.',
          detail: [
            {
              name: '',
              descriptions: [
                {
                  description:
                    'This portal is now hosted, and globally balanced, from dozens of data centers around the world. This means that it will be fast, no matter where you are.',
                },
              ],
            },
            {
              name: 'A new ticket system',
              descriptions: [
                {
                  description: 'An entirely new ticket system has been introduced.',
                },
                {
                  description:
                    'The ability to leave notes to staff, such as a shift hand off message or to inform them to monitor something during the night.',
                },
                {
                  description:
                    'New automated alerts, such as HVs that are low on RAM or backends that are not responding.',
                },
                {
                  description: `Ability to leave notes to staff related to a ticket, such as "build a server for a client with the following specs".`,
                },
                {
                  description: `Staff must now write a summary of a ticket before closing it.`,
                },
                {
                  description: `A new search function that, so far, will search for tickets of a specific username.`,
                },
              ],
            },
          ],
        },
      ],
    },
  ];
  